"use client";
import * as React from "react";
const SvgWorkOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.4 3.37h3.4c.94 0 1.7.75 1.7 1.68v9.27c0 .93-.76 1.68-1.7 1.68H2.2c-.94 0-1.7-.75-1.7-1.68V5.05a1.7 1.7 0 0 1 1.7-1.68h3.4V1.68C5.6.75 6.36 0 7.3 0h3.4c.94 0 1.7.75 1.7 1.68zm-5.1 0h3.4V1.68H7.3zm8.5 1.68H2.2v9.27h13.6z", clipRule: "evenodd" }));
export {
  SvgWorkOutlined as default
};
